import { render, staticRenderFns } from "./InterviewViewPage.vue?vue&type=template&id=21bdf97d"
import script from "./InterviewViewPage.vue?vue&type=script&lang=js"
export * from "./InterviewViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports